// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"3df745fd","800":"c2383ab4"}[chunkId] + ".chunk.js";
};